import { Injectable, inject } from '@angular/core';
import {BehaviorSubject, forkJoin, Observable} from 'rxjs';
import {PrintConfig, PrintData} from '../models/print-data';
import {map} from 'rxjs/operators';
import {ProjectReferencePhotoService} from './project-reference-photo.service';
import {ProjectReferenceAttributeService} from './project-reference-attribute.service';
import {ProjectRelationService} from './project-relation.service';
import {TeamMemberService} from './team-member.service';
import {ProjectReferenceContractAttributesService} from './project-reference-contract-attributes.service';

@Injectable({
    providedIn: 'root'
})
export class PrintDataService {
    private projectReferencePhotoService = inject<ProjectReferencePhotoService>('ProjectReferencePhotoService' as any);
    private projectReferenceAttributeService = inject<ProjectReferenceAttributeService>('ProjectReferenceAttributeService' as any);
    private projectRelationService = inject<ProjectRelationService>('ProjectRelationService' as any);
    private teamMemberService = inject<TeamMemberService>('TeamMemberService' as any);
    private projectReferenceContractAttributesService = inject<ProjectReferenceContractAttributesService>('ProjectReferenceContractAttributesService' as any);

    readonly printConfig$ = new BehaviorSubject<PrintConfig | null>(null);

    loadUnfilteredPrintData(projectReferenceId: number): Observable<PrintData> {
        return forkJoin([
            this.projectReferencePhotoService.getPhotos(projectReferenceId),
            this.projectReferenceAttributeService.listAttributes(projectReferenceId).pipe(
                map(attributes => {
                    const {readonlyAttributes, ...rest} = attributes;
                    return {...rest, ...readonlyAttributes}
                })
            ),
            this.projectReferenceContractAttributesService.getContractAttributes(projectReferenceId),
            this.projectRelationService.list(projectReferenceId),
            this.teamMemberService.list(projectReferenceId),
        ]).pipe(
            map(([photos, attributes, contractAttributes, relations, teamMembers]) => {
                return {
                    photos,
                    attributes,
                    contractAttributes,
                    relations,
                    teamMembers
                }
            })
        );
    }
}
